/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const SN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="500"
    height="300"
    viewBox="0 0 500 300"
    {...props}
  >
    <rect
      fill="#166c23"
      width="500"
      height="300"
    />
    <rect
      fill="#fff"
      width="500"
      height="150"
    />
  </svg>
);
export default memo(SN);
